import * as React from "react";
import {
  Paper,
  Typography,
  Stack,
  Box,
  Button,
} from "@mui/material";
import { Colors } from "../../utils/Colors";

const prescriptionList = [
  {
    id: 1,
    patient: "Riya Sharma",
    medicine: "Paracetamol 650 mg",
    dose: "1 tablet twice daily",
  },
  {
    id: 2,
    patient: "Vikas Singh",
    medicine: "Amoxicillin 500 mg",
    dose: "1 capsule three times daily",
  },
  {
    id: 3,
    patient: "Neha Gupta",
    medicine: "Pantoprazole 40 mg",
    dose: "1 tablet before breakfast",
  },
];

export default function DoctorPrescriptions() {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.2,
        borderRadius: 4,
        bgcolor: Colors.bg.paper,
        border: `1px solid ${Colors.border.light}`,
        height: "100%",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 800, color: Colors.text.title }}
        >
          Recent Prescriptions
        </Typography>

        <Button
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 3,
            bgcolor: Colors.brand.primary,
            "&:hover": {
              bgcolor: Colors.brand.primaryDark,
            },
          }}
        >
          Add New
        </Button>
      </Stack>

      <Stack spacing={1.5}>
        {prescriptionList.map((item) => (
          <Box
            key={item.id}
            sx={{
              p: 1.6,
              borderRadius: 3,
              bgcolor: Colors.bg.app,
              border: `1px solid ${Colors.border.light}`,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 700, color: Colors.text.title }}
            >
              {item.patient}
            </Typography>
            <Typography variant="body2" sx={{ color: Colors.text.body, mt: 0.6 }}>
              {item.medicine}
            </Typography>
            <Typography variant="caption" sx={{ color: Colors.text.muted }}>
              {item.dose}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}